// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `details > summary {
  list-style: none;
}

details > summary::-webkit-details-marker {
  display: none;
}

.range-selector {
  position: relative;
}
.range-selector summary {
  position: relative;
  cursor: pointer;
  height: 50px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border: 1px solid rgb(239, 239, 239);
  border-radius: 4px;
  background: transparent;
  transition: border-color 0.2s ease;
}
.range-selector summary .value {
  font-size: 16px;
  color: var(--ion-color-dark, #222);
}
.range-selector summary .label {
  position: absolute;
  left: 12px;
  padding: 0 4px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: var(--ion-color-medium, #666);
  background: transparent;
  pointer-events: none;
  transition: top 0.15s ease-in-out, font-size 0.15s ease-in-out, color 0.15s ease-in-out;
}
.range-selector summary.is-floating .label {
  top: 0;
  font-size: 12px;
  background: white;
}
.range-selector .inputs {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  display: flex;
  gap: 12px;
  padding: 16px;
  margin-top: 4px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid var(--ion-color-step-150, #eee);
}
.range-selector .inputs ion-input {
  width: 120px;
}
.range-selector .error-msg {
  position: absolute;
  top: calc(100% + 80px);
  left: 0;
  color: var(--ion-color-danger, #eb445a);
  font-size: 12px;
  padding-left: 16px;
  margin-top: 4px;
}

::ng-deep input[type=number]::-webkit-inner-spin-button,
::ng-deep input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::ng-deep input[type=number] {
  -moz-appearance: textfield;
}

details > summary {
  list-style: none;
}

details > summary::-webkit-details-marker {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/components/integer-range-selector/integer-range-selector.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,kBAAA;AAEF;AAAE;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,uBAAA;EACA,kCAAA;AAEJ;AAAI;EACE,eAAA;EACA,kCAAA;AAEN;AACI;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,oCAAA;EACA,uBAAA;EACA,oBAAA;EACA,uFACE;AAAR;AAKI;EACE,MAAA;EACA,eAAA;EACA,iBAAA;AAHN;AAOE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EAEA,aAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EAEA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,iDAAA;AAPJ;AASI;EACE,YAAA;AAPN;AAWE;EACE,kBAAA;EACA,sBAAA;EACA,OAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AATJ;;AAaA;;EAEE,wBAAA;EACA,SAAA;AAVF;;AAYA;EACE,0BAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAWA;EACE,aAAA;AARF","sourcesContent":["details > summary {\n  list-style: none;\n}\ndetails > summary::-webkit-details-marker {\n  display: none;\n}\n\n.range-selector {\n  position: relative;\n\n  summary {\n    position: relative;\n    cursor: pointer;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    padding: 0 16px;\n    border: 1px solid rgba(239, 239, 239, 1);\n    border-radius: 4px;\n    background: transparent;\n    transition: border-color 0.2s ease;\n\n    .value {\n      font-size: 16px;\n      color: var(--ion-color-dark, #222);\n    }\n\n    .label {\n      position: absolute;\n      left: 12px;\n      padding: 0 4px;\n      top: 50%;\n      transform: translateY(-50%);\n      font-size: 16px;\n      color: var(--ion-color-medium, #666);\n      background: transparent;\n      pointer-events: none;\n      transition:\n        top 0.15s ease-in-out,\n        font-size 0.15s ease-in-out,\n        color 0.15s ease-in-out;\n    }\n\n    &.is-floating .label {\n      top: 0;\n      font-size: 12px;\n      background: white;\n    }\n  }\n\n  .inputs {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 10;\n\n    display: flex;\n    gap: 12px;\n    padding: 16px;\n    margin-top: 4px;\n\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n    border: 1px solid var(--ion-color-step-150, #eee);\n\n    ion-input {\n      width: 120px;\n    }\n  }\n\n  .error-msg {\n    position: absolute;\n    top: calc(100% + 80px);\n    left: 0;\n    color: var(--ion-color-danger, #eb445a);\n    font-size: 12px;\n    padding-left: 16px;\n    margin-top: 4px;\n  }\n}\n\n::ng-deep input[type=\"number\"]::-webkit-inner-spin-button,\n::ng-deep input[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n::ng-deep input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\ndetails > summary {\n  list-style: none;\n}\ndetails > summary::-webkit-details-marker {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
